
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { User, UserRole } from '../../system/types';
import UserTableRow from './UserTableRow';

interface UserTableProps {
  users: User[];
  editing: boolean;
  onEditUser: (user: User) => void;
  onDeleteUser: (user: User) => void;
  roleLabels: Record<UserRole, string>;
}

const UserTable: React.FC<UserTableProps> = ({
  users,
  editing,
  onEditUser,
  onDeleteUser,
  roleLabels
}) => {
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Department</TableHead>
            <TableHead>Source</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.length > 0 ? (
            users.map((user) => (
              <UserTableRow
                key={user.id}
                user={user}
                editing={editing}
                onEditUser={onEditUser}
                onDeleteUser={onDeleteUser}
                roleLabels={roleLabels}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} className="h-24 text-center">
                No users found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default UserTable;
